// src/pages/profile-settings/screens/LoginSecurityPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import SettingsScreenShell from "@/sot/layouts/SettingsScreenShell.jsx";
import LoginSecurityCommon from "@/features/settings/LoginSecurityCommon.jsx";

export default function LoginSecurityPage() {
  const nav = useNavigate();

  return (
    <SettingsScreenShell>
      <LoginSecurityCommon
        withTopBar
        onBack={() => nav("/settings/patient")}
        basePath="/settings/patient/login-security"
      />
    </SettingsScreenShell>
  );
}
